import { IRootProps } from "../interfaces";

export default function LayoutContent({ children }: IRootProps) {
  return <>{children}</>;
}
